import {useMemo} from 'react';
import {getIVOnPropertyState, type IVOnPropertyState} from '@chekin/shared/guest-form';
import {useReservation} from 'context/reservation';
import {useSchema} from 'context/guest';

function useIVOnProperty(): IVOnPropertyState {
  const {data: reservation, housing} = useReservation();
  const {
    identityVerificationDetails: {enabled: isIVEnabled},
  } = useSchema();

  return useMemo(
    () =>
      getIVOnPropertyState({
        isIVEnabled,
        processType: housing?.identity_verification_process_type,
        checkInDate: reservation?.check_in_date,
        checkOutDate: reservation?.check_out_date,
      }),
    [
      isIVEnabled,
      housing?.identity_verification_process_type,
      reservation?.check_in_date,
      reservation?.check_out_date,
    ],
  );
}

export {useIVOnProperty};
